import type from './user-clicked-volume-toggle.type';

const userClickedVolumeToggle = () => ({ type });

export default userClickedVolumeToggle;
